const shopifyShopUrl =
  new URL(window.location).searchParams.get("shop") ??
  process.env.SHOPIFY_SHOP_URL;

export default function useShopifyShopUrl() {
  return shopifyShopUrl;
}
